import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {NgbCalendar, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {forkJoin, Observable, Subscription} from 'rxjs';
import {PlanningRegionApiService} from '../../../services/api/planning-region-api.service';
import {RegionGroup, PlanningRegion} from '../../../models/planning_region.model';
import {dateUtils} from '../../../helpers/date.utils';
import {addDays} from 'date-fns';
import {BaseComponent} from "../../../shared/base/base.component";
import {Region, Regions} from "../../../models/region.model";
import {Title} from "@angular/platform-browser";

@Component({
  selector: '[app-planning-region]',
  templateUrl: './planning-region.component.html',
  styleUrls: ['./planning-region.component.scss'],
})
export class PlanningRegionComponent extends BaseComponent implements OnDestroy, OnInit {
  data: PlanningRegion = this.initializeData();
  loadingInitial = false;
  loading = false;
  dateControl = new FormControl();
  regions: RegionGroup[] = [];

  private reloadPlanningSubscription = new Subscription();
  private dateChangeSubscription = new Subscription();

  constructor(
    private planningRegionApiService: PlanningRegionApiService,
    private calendar: NgbCalendar,
    private titleService: Title,
  ) {
    super();
  }

  ngOnInit(): void {
    const initialDate = this.calendar.getToday();
    this.dateControl.setValue(initialDate);
    this.dateChangeSubscription = this.subscribeToDateChanges();
    this.reloadPlanningSubscription = this.planningRegionApiService.reloadPlanningRegion$.subscribe((regionId) => {
      const loading = this.idRegion !== regionId;
      if (regionId) { this.idRegion = regionId; }
      this.loadRegionData(
        {
          wedn: dateUtils.formatDateStruct(dateUtils.toDate(this.dateControl.value)),
          loading: loading
        }
      );
    });
  }

  ngOnDestroy(): void {
    this.reloadPlanningSubscription.unsubscribe();
    this.dateChangeSubscription.unsubscribe();
  }

  createRegions(data: Regions): RegionGroup[] {
    const regions: RegionGroup[] = [];
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        data[key].forEach((group: Region) => {
          regions.push({
            id_region: group.id_group,
            label: group.nom_group,
            path: `#/planning-region/${group.id_group}/${this.cookies}`
          });
        });
      }
    }
    return regions;
  }

  private subscribeToDateChanges(): Subscription {
    return this.dateControl.valueChanges.subscribe((date: NgbDateStruct | null) => {
      const currentDateStruct = dateUtils.parseDateToNgbDateStruct(this.data.wedns?.[0] || '');
      if (date && (!currentDateStruct || date.year !== currentDateStruct.year || date.month !== currentDateStruct.month || date.day !== currentDateStruct.day)) {
        this.onDateSelect(date);
      }
    });
  }

  private initializeData(): PlanningRegion {
    return {
      prog: {},
      max_films: 0,
      cinemas: [],
      screen_comment: {},
      prog_annonce: {},
      all_screen: [],
      versions: {},
    };
  }

  public loadRegionData({ wedn, loading = true }: { wedn: string; loading?: boolean }): void {
    loading? this.loadingInitial = true : this.loadingInitial = false;

    const $data = this.planningRegionApiService.fetchRegionData(this.cookies, this.idRegion, wedn) as Observable<PlanningRegion>;
    const $regions = this.planningRegionApiService.fetchGroups(this.cookies) as Observable<Regions>;

    forkJoin([$data, $regions]).subscribe({
      next: ([PlanningRegionData, Regions]: [PlanningRegion, Regions]) => {
        this.data = PlanningRegionData;
        this.regions = this.createRegions(Regions);
        this.dateControl.setValue(dateUtils.parseDateToNgbDateStruct(this.data.wedns?.[0] || ''));
        this.loadingInitial = false;
        this.setRegionTabName();
      },
      error: () => {
        this.loadingInitial = false;
      }
    });
  }

  navigateTable(direction: number): void {
    if (!this.dateControl.value) {
      this.loading = false;
      return;
    }
    const currentDate = dateUtils.toDate(this.dateControl.value);
    const newDate = addDays(currentDate, direction * 7);
    this.dateControl.setValue({ year: newDate.getFullYear(), month: newDate.getMonth() + 1, day: newDate.getDate() });
  }

  onDateSelect(date: NgbDateStruct | null): void {
    if (!date) return;
    const formattedDate = dateUtils.formatDateStruct(dateUtils.toDate(date));
    this.loadRegionData({wedn: formattedDate});
    }

  setRegionTabName(): void {
    const region = this.regions.find(region => region.id_region === this.idRegion);
    const regionName = region ? region.label : '';
    this.titleService.setTitle(regionName);
  }

}
